import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLocalizedString } from "@icarius-localization/strings";
import { getConceptGroupsAction } from "../actions";
import { getLoading, getRows } from "../selectors";
import { getAppColor } from "@icarius-app/selectors";
import paths from "@icarius-router/paths";
import { Grid } from "@material-ui/core";
import ABMLayout from "@icarius-common/abmComponents/abmLayout";
import DataItem from "./data/dataItem";
import { RESET_STATE } from "../actionTypes";

const ConceptGroups = ({ history }) => {
    const [createIsOpen, setCreateIsOpen] = useState(false);

    const dispatch = useDispatch();
    const data = useSelector(getRows);
    const isLoading = useSelector(getLoading);
    const color = useSelector(getAppColor);

    useEffect(() => {
        dispatch(getConceptGroupsAction());
        return () => dispatch({ type: RESET_STATE });
    }, [dispatch]);

    const getDataIsEmpty = () => {
        return !data || data.length === 0;
    };

    const handleGoBack = () => {
        history.push(paths.conceptsAndFormulasScreenSelector);
    };

    const handleCreateClick = () => {
        if (data?.length < 12) {
            setCreateIsOpen(true);
        }
    };

    return (
        <ABMLayout
            title={getLocalizedString("conceptGroups")}
            isLoading={isLoading}
            showCreateButton={!createIsOpen && data?.length < 12}
            createButtonTitle={getLocalizedString("newConceptGroup")}
            createButtonOnClick={handleCreateClick}
            showGoBack
            handleGoBack={handleGoBack}
            showNoData={getDataIsEmpty()}
            noDataTitle={getLocalizedString("noJobGroupsFoundForConcept")}
            noDataCreateTitle={getLocalizedString("newConceptGroupAlt")}
            noDataOnClick={() => setCreateIsOpen(true)}
        >
            {createIsOpen && (
                <Grid container item xs={12} style={{ margin: "10px 0px" }}>
                    <DataItem
                        color={color}
                        data={null}
                        length={data?.length || 0}
                        closeNew={() => setCreateIsOpen(false)}
                    />
                </Grid>
            )}
            {data &&
                data.map((item) => {
                    return (
                        <Grid container item xs={12} style={{ margin: "10px 0px" }} key={item.number}>
                            <DataItem data={item} length={data.length} color={color} />
                        </Grid>
                    );
                })}
        </ABMLayout>
    );
};

export default ConceptGroups;
